import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-b67b2b1e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "home-header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "logo-container"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "logo"
}), /*#__PURE__*/_createElementVNode("h1", null, "压图")])], -1));
const _hoisted_3 = {
  class: "page-content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "page-title"
}, "编程处理工具", -1));
const _hoisted_5 = {
  class: "home-footer"
};
import codeNav from './codeNav.vue';
export default {
  __name: 'HomePage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("main", _hoisted_3, [_hoisted_4, _createVNode(codeNav)]), _createElementVNode("footer", _hoisted_5, [_createElementVNode("p", null, "© " + _toDisplayString(new Date().getFullYear()) + " 压图 . 保留所有权利.", 1)])]);
    };
  }
};